import "./javascripts/shared/global/babel-polyfill.js";